import { render, staticRenderFns } from "./SpeakTextContent.vue?vue&type=template&id=6de492db&"
import script from "./SpeakTextContent.vue?vue&type=script&lang=js&"
export * from "./SpeakTextContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports